// src/pages/MasInformacion/MasInformacion.jsx
import React, { useState } from 'react';
import './MasInformacion.css';

const MasInformacion = () => {
  const [showSocialModal, setShowSocialModal] = useState(false);
  // Funciones para manejar los botones de contacto
  const handleDiscordClick = () => {
    // Enlace al servidor de Discord
    window.open('https://discord.gg/GXr37Wr8CJ', '_blank');
  };

  const handleTicketClick = () => {
    // Canal de tickets en Discord
    window.open('https://discord.com/channels/1389730124542513303/1389730128648605868', '_blank');
  };

  const handleSocialClick = () => {
    setShowSocialModal(true);
  };

  return (
    <div className="mas-informacion">
      <div className="mas-informacion-hero">
        <div className="hero-content">
          <h1>Más Información</h1>
          <p>Conoce más sobre nuestro servidor de roleplay de servicios de emergencias y únete a los cuerpos</p>
        </div>
      </div>

      <div className="mas-informacion-content">
        <div className="info-section">
          <div className="section-header">
            <h2>🎮 Sobre el Servidor</h2>
          </div>
          <div className="info-grid">
            <div className="info-card">
              <div className="info-card-icon">🚑</div>
              <h3>Servicios de Emergencias</h3>
              <p>Experimenta un roleplay realista de servicios de emergencias. Policía, bomberos, 061 y otros cuerpos trabajando juntos para proteger la ciudad.</p>
            </div>
            <div className="info-card">
              <div className="info-card-icon">👥</div>
              <h3>Comunidad en Crecimiento</h3>
              <p>Una nueva comunidad de emergencias que está creciendo día a día, con profesionales comprometidos creando situaciones realistas y auténticas.</p>
            </div>
            <div className="info-card">
              <div className="info-card-icon">🏢</div>
              <h3>Múltiples Cuerpos</h3>
              <p>Únete a diferentes cuerpos: Policía Nacional, Guardia Civil, Bomberos, 061, Protección Civil y más. Cada uno con protocolos específicos.</p>
            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="section-header">
            <h2>🛡️ Principales Reglas del Servidor</h2>
          </div>
          <div className="rules-container">
            <div className="rule-item">
              <div className="rule-number">1</div>
              <div className="rule-content">
                <h4>Respeto Mutuo</h4>
                <p>Mantén siempre el respeto hacia otros jugadores, tanto dentro como fuera del juego.</p>
              </div>
            </div>
            <div className="rule-item">
              <div className="rule-number">2</div>
              <div className="rule-content">
                <h4>Roleplay Realista</h4>
                <p>Actúa de manera realista según tu personaje y evita situaciones irreales o absurdas.</p>
              </div>
            </div>
            <div className="rule-item">
              <div className="rule-number">3</div>
              <div className="rule-content">
                <h4>No Metagaming</h4>
                <p>No uses información obtenida fuera del juego para beneficiar a tu personaje.</p>
              </div>
            </div>
            <div className="rule-item">
              <div className="rule-number">4</div>
              <div className="rule-content">
                <h4>No RDM/VDM</h4>
                <p>Prohibido matar o atropellar sin razón válida dentro del roleplay.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="section-header">
            <h2>🔧 Características Técnicas</h2>
          </div>
          <div className="tech-specs">
            <div className="spec-row">
              <span className="spec-label">Framework:</span>
              <span className="spec-value">Qbox</span>
            </div>

            <div className="spec-row">
              <span className="spec-label">Slots:</span>
              <span className="spec-value">64 Jugadores</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Ubicación:</span>
              <span className="spec-value">España</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Uptime:</span>
              <span className="spec-value">99.9%</span>
            </div>
            <div className="spec-row">
              <span className="spec-label">Versión:</span>
              <span className="spec-value">FiveM Latest</span>
            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="section-header">
            <h2>📞 Contacto y Soporte</h2>
          </div>
          <div className="contact-grid">
            <div className="contact-card">
              <div className="contact-icon">💬</div>
              <h4>Discord</h4>
              <p>Únete a nuestro servidor de Discord para soporte y comunidad</p>
              <button className="contact-btn" onClick={handleDiscordClick}>
                Unirse al Discord
              </button>
            </div>
            <div className="contact-card">
              <div className="contact-icon">🎫</div>
              <h4>Tickets</h4>
              <p>Abre un ticket para resolver dudas o reportar problemas</p>
              <button className="contact-btn" onClick={handleTicketClick}>
                Abrir Ticket
              </button>
            </div>
            <div className="contact-card">
              <div className="contact-icon">📱</div>
              <h4>Redes Sociales</h4>
              <p>Síguenos en nuestras redes sociales para estar al día</p>
              <button className="contact-btn" onClick={handleSocialClick}>
                Ver Redes
              </button>
            </div>
          </div>
        </div>

        <div className="info-section">
          <div className="section-header">
            <h2>❓ Preguntas Frecuentes</h2>
          </div>
          <div className="faq-container">
            <div className="faq-item">
              <h4>¿Cómo puedo unirme al servidor?</h4>
              <p>Primero debes completar el proceso de whitelist en nuestra web. Una vez aprobado, podrás conectarte al servidor usando la IP que te proporcionaremos.</p>
            </div>
            <div className="faq-item">
              <h4>¿Necesito algún mod o descarga adicional?</h4>
              <p>Solo necesitas FiveM instalado. Todos los recursos y mods se descargan automáticamente al conectarte por primera vez.</p>
            </div>
            <div className="faq-item">
              <h4>¿Cuánto tiempo tarda la whitelist?</h4>
              <p>El proceso de whitelist suele tardar entre 24-48 horas. Recibirás una notificación por email cuando sea aprobada.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Redes Sociales */}
      {showSocialModal && (
        <div className="social-modal-overlay" onClick={() => setShowSocialModal(false)}>
          <div className="social-modal" onClick={(e) => e.stopPropagation()}>
            <div className="social-modal-header">
              <h3>🔗 Nuestras Redes Sociales</h3>
              <button 
                className="social-modal-close"
                onClick={() => setShowSocialModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="social-links-grid">
              <a 
                href="https://discord.gg/GXr37Wr8CJ" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link discord"
              >
                <div className="social-icon">💬</div>
                <div className="social-info">
                  <h4>Discord</h4>
                  <p>Únete a nuestra comunidad</p>
                </div>
              </a>
              {/* Redes sociales para activar en el futuro - Solo descomenta las que quieras usar */}
              
              {/* INSTAGRAM - Descomenta cuando tengas perfil activo
              <a 
                href="https://instagram.com/proyectorp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link instagram"
              >
                <div className="social-icon">📷</div>
                <div className="social-info">
                  <h4>Instagram</h4>
                  <p>@proyectorp_oficial</p>
                </div>
              </a>
              */}
              
              {/* YOUTUBE - Descomenta cuando tengas canal activo
              <a 
                href="https://youtube.com/@proyectorp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link youtube"
              >
                <div className="social-icon">📺</div>
                <div className="social-info">
                  <h4>YouTube</h4>
                  <p>Proyecto RP</p>
                </div>
              </a>
              */}
              
              <a 
                href="https://www.tiktok.com/@riasbaixas_pd" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link tiktok"
              >
                <div className="social-icon">🎵</div>
                <div className="social-info">
                  <h4>TikTok</h4>
                  <p>@riasbaixas_pd</p>
                </div>
              </a>
              
              {/* TWITCH - Descomenta cuando tengas streams activos
              <a 
                href="https://twitch.tv/proyectorp" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link twitch"
              >
                <div className="social-icon">🎮</div>
                <div className="social-info">
                  <h4>Twitch</h4>
                  <p>Streams en vivo</p>
                </div>
              </a>
              */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasInformacion;